import { InvestmentObjectives } from '@shared/models';

export const normalizeObjectives = (
  o: Partial<InvestmentObjectives> | null | undefined,
): InvestmentObjectives => ({
  CAP: o?.CAP ?? null,
  Income: o?.Income ?? null,
  Growth: o?.Growth ?? null,
  Speculation: o?.Speculation ?? null,
});

export const toBooleanStatus = (o?: Partial<InvestmentObjectives> | null): boolean =>
  !!o && Object.values(o).some((v) => v === true);
